export default __webpack_public_path__ + "static/media/DANA_TOKEN.60ee0a4e.png";